import { IconButton, Popover } from "@material-ui/core";
import React from "react";
import MeetingDetailsComponent from "../CustomComponents/MeetingDetailsComponent";
import IncomePerYearComponent from "../CustomComponents/IncomePerYearComponent";
import MagicFieldsComponent from "../CustomComponents/MagicFieldsComponent";
import AddressComponent from "../CustomComponents/AddressComponent";
import DueDiligenceComponent from "../CustomComponents/DueDiligenceComponent";

const predefinedCustomComponents = (key, customProps) => {
  switch (key) {
    case "meetingDetails":
      return <MeetingDetailsComponent {...customProps} />;
    case "incomePerYear":
      return <IncomePerYearComponent {...customProps} />;
    case "magicFields":
      return <MagicFieldsComponent {...customProps} />;
    case "orgAddress":
      return <AddressComponent {...customProps} />;
    case "dueDiligenceDetails":
      return <DueDiligenceComponent {...customProps} />;
    default:
      return "-";
  }
};
const CustomRendererPopup = (props) => {
  const {
    isCustomPopupOpen,
    handleClose,
    customAnchor,
    ...customSpecificProps
  } = props;

  const { customComponentKey } = customSpecificProps.cell.column.columnDef;

  return (
    <>
      {isCustomPopupOpen && customAnchor ? (
        <Popover
          open={isCustomPopupOpen}
          onClose={handleClose}
          elevation={4}
          anchorEl={customAnchor}
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          style={{
            height: "450px",
          }}
          PaperProps={{
            style: {
              width: "350px",
              height: "450px",
              padding: "0.75rem",
              maxHeight: "400px",
              zIndex: "15",
            },
          }}
          marginThreshold={32}
        >
          {predefinedCustomComponents(customComponentKey, {
            ...customSpecificProps,
            handleClose,
          })}
        </Popover>
      ) : null}
    </>
  );
};
export default CustomRendererPopup;
